import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

interface DualLogoHeaderProps {
  partnerName: string;
  partnerLogoUrl?: string | null;
  partnerIconUrl?: string | null;
  partnerBrandColor?: string | null;
}

export default function DualLogoHeader({
  partnerName,
  partnerLogoUrl,
  partnerIconUrl,
  partnerBrandColor,
}: DualLogoHeaderProps) {
  const { theme } = useTheme();
  const [logoError, setLogoError] = useState(false);
  const partnerLogo = logoError ? null : partnerLogoUrl || partnerIconUrl;

  return (
    <div className='flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 mb-8'>
      <img
        src={theme === 'light' ? '/img/6tool-logo-light-background.svg' : '/img/6tool-logo.svg'}
        alt='6Tool'
        className='h-12 w-auto'
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = '/img/logo.png';
        }}
      />

      <span
        className='text-2xl sm:text-3xl text-gray-400 dark:text-gray-500 select-none'
        aria-hidden='true'
      >
        ↔
      </span>

      {partnerLogo ? (
        <img
          src={partnerLogo}
          alt={partnerName}
          className='h-12 w-auto max-w-[160px] object-contain'
          onError={() => setLogoError(true)}
        />
      ) : (
        <div
          className='h-12 px-4 rounded-lg flex items-center justify-center text-white font-semibold text-lg'
          style={{ backgroundColor: partnerBrandColor || '#4A45B0' }}
        >
          {partnerName}
        </div>
      )}
    </div>
  );
}
